import { render } from "./ShimmerProfileDrawerModal.vue?vue&type=template&id=589544ce"
import script from "./ShimmerProfileDrawerModal.vue?vue&type=script&lang=js"
export * from "./ShimmerProfileDrawerModal.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__